export enum FileView {
  Tile = 'tile',
  Row = 'row'
}
